import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckinBaseComponent } from '@common/components';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-checkin-review-sub-header',
  templateUrl: './checkin-review-sub-header.component.html',
  styleUrls: ['./checkin-review-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinReviewSubHeaderComponent extends CheckinBaseComponent {
  /** ページタイトル */
  pageTitle?: string;

  constructor(commonService: CommonLibService) {
    super(commonService);
  }

  override reload(): void {}
  override init(): void {}
  override destroy(): void {}
}
